import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=e9b3f634&scoped=true"
import script from "./ConfigurationList.vue?vue&type=script&lang=js"
export * from "./ConfigurationList.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationList.vue?vue&type=style&index=0&id=e9b3f634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b3f634",
  null
  
)

export default component.exports